import styled from 'styled-components';
import * as palette from '@mlc/mlc-palette';
import {
	TableRow as TableRowComponent,
	TableCell as TableCellComponent,
	Paragraph,
} from '@mlc/web-ui-toolkit';

export const TableRow = styled(TableRowComponent)`
	border-bottom: 1px ${palette.mlcDove} solid;
`;

export const TableRowHeader = styled(TableRowComponent)`
	&& {
		background-color: ${palette.mlcLightGrey};
		background-image: none;
	}
`;

export const TableCell = styled(TableCellComponent)`
	padding: 16px 10px 16px 5px;
`;

export const ClientDetails = styled(Paragraph)`
	color: ${palette.mlcVeryDarkGrey};
	margin: 0;
`;
